import { InjectionToken } from "@angular/core";

export const NAVIGATOR_TOKEN = new InjectionToken<Navigator>("NavigatorToken", {
    providedIn: "root",
    factory: () => navigator
});
